import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function PortfolioSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const portfolioItems = [
    {
      id: 1,
      title: "Healthcare",
      category: "Silicon Valley Innovation Hub",
      type: "collage",
      images: [
        "/assets/Gallery/Healthcare-1.jpg",
        "/assets/Gallery/Healthcare-2.jpg",
        "/assets/Gallery/Healthcare-3.jpg",
        "/assets/Gallery/Healthcare-4.jpg",
        "/assets/Gallery/Healthcare-5.jpg",
         "/assets/Gallery/Healthcare-6.jpg",
   
      ],
    },
    {
      id: 2,
      title: "Hospitality and Entertainment",
      category: "Fortune 500 Headquarters",
      type: "collage",
      images: [
        "/assets/Gallery/hospitality-1.png",
        "/assets/Gallery/hospitality-2.png",
        "/assets/Gallery/hospitality-3.png",
        "/assets/Gallery/hospitality-4.png",
        "/assets/Gallery/hospitality-5.png",
        "/assets/Gallery/Entertainment-2.jpg"
      ],
    },
    {
      id: 3,
      title: "Coffee Shops & Restaurants",
      category: "Design & Innovation Space",
      type: "collage",
      images: [
        "/assets/Gallery/COFEE-SHOPS-1.jpg",
        "/assets/Gallery/COFEE-SHOPS-2.jpg",
        "/assets/Gallery/COFEE-SHOPS-3.jpg",
        "/assets/Gallery/COFEE-SHOPS-4.jpg",
        "/assets/Gallery/COFEE-SHOPS-5.jpg",
        "/assets/Gallery/COFEE-SHOPS-6.jpg"
      ],
    },
    {
      id: 4,
      title: "Residential",
      category: "Corporate Excellence",
      type: "collage",
      images: [ 
        "/assets/Gallery/RESIDENTIAL-1.jpg",
        "/assets/Gallery/RESIDENTIAL-2.jpg",
       
      
      ],
    },
    {
      id: 5,
      title: "Corporate ",
      category: "Luxury Retail",
      type: "collage",
      images: [
        "/assets/Gallery/CORPORATE-1.jpg",
        "/assets/Gallery/CORPORATE-2.jpg",
        "/assets/Gallery/CORPORATE-3.jpg",
        "/assets/Gallery/CORPORATE-4.jpg",
        "/assets/Gallery/CORPORATE-5.jpg",
        "/assets/Gallery/CORPORATE-6.jpg"
      ]
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % portfolioItems.length);
    }, 12000);
    return () => clearInterval(timer);
  }, [portfolioItems.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % portfolioItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + portfolioItems.length) % portfolioItems.length
    );
  };

  return (
    <section
      id="gallery"
      className="relative py-16 bg-gradient-to-b from-gray-900 via-slate-800 to-gray-900 overflow-hidden"
    >
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600/20 to-red-700/20 backdrop-blur-sm border border-red-400/30 rounded-full px-4 py-2 mb-4">
            <i className="ri-gallery-line text-red-400"></i>
            <span className="text-red-300 font-medium text-sm">Projects</span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            <span className="text-gray-100 mr-2">Sectoral</span>
            <span className="bg-gradient-to-r from-red-500 via-red-600 to-red-700 bg-clip-text text-transparent">
              Experience
            </span>
          </h2>

          <p className="text-base text-gray-300 max-w-2xl mx-auto leading-relaxed">
            We have set out some of the most prestigious projects across the
            region, and we are proud to have delivered our projects to the
            clients satisfaction.
          </p>
        </motion.div>

        {/* Portfolio Slider */}
        <div className="relative">
          <div className="relative h-[400px] rounded-2xl overflow-hidden bg-gradient-to-br from-gray-800 to-slate-900 border border-gray-700/50">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentSlide}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6 }}
                className="absolute inset-0"
              >
                {/* Collage or Single Image */}
                {portfolioItems[currentSlide].type === "collage" ? (
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-2 h-full p-2 bg-gray-900/70">
                    {portfolioItems[currentSlide].images.map((img, index) => (
                      <motion.div
                        key={index}
                        className="overflow-hidden rounded-lg"
                        initial={{ scale: 1.1, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ delay: index * 0.1 }}
                      >
                        <img
                          src={img}
                          alt={`Collage ${index + 1}`}
                          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                        />
                      </motion.div>
                    ))}
                  </div>
                ) : (
                  <>
                   
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-slate-800/70 to-transparent"></div>
                  </>
                )}

                {/* 👇 Slide Heading Overlay */}
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  className="absolute bottom-6 left-6 bg-gray-900/70 backdrop-blur-sm border border-gray-600/40 px-4 py-3 rounded-xl shadow-lg max-w-[80%]"
                >
                  
                  <h3 className="text-lg md:text-xl font-semibold text-white leading-tight">
                    {portfolioItems[currentSlide].title}
                  </h3>
                </motion.div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-gray-800/80 backdrop-blur-sm border border-gray-600/50 rounded-full flex items-center justify-center text-gray-300 hover:text-red-400 hover:border-red-400/50 transition-all duration-300 z-10"
          >
            <i className="ri-arrow-left-line text-lg"></i>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-gray-800/80 backdrop-blur-sm border border-gray-600/50 rounded-full flex items-center justify-center text-gray-300 hover:text-red-400 hover:border-red-400/50 transition-all duration-300 z-10"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>

          {/* Indicators */}
          <motion.div
            key={currentSlide}
            className="absolute bottom-4 left-4 flex space-x-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            {portfolioItems.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentSlide
                    ? "w-6 h-2 bg-gradient-to-r from-red-600 to-red-700"
                    : "w-2 h-2 bg-gray-600 hover:bg-gray-500"
                }`}
              />
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}